module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAXBAMAAAAIOCkdAAAAAXNSR0IB2cksfwAAABVQTFRFAAAA////////////////////////SM9tBAAAAAd0Uk5TAAggGIBgSBGUgcQAAAAqSURBVHicY2CAAyElJQMEj0HFxSVgYLlgByG4YBYRXIQ2+hKmoaEJCAIAAqwrtIWYDqUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/side-menu-analytics.png
// module id = 949
// module chunks = 0